import { ReactElement } from 'react';

import LoadingSpinnerIcon from '@/icons/loadingSpinner';

interface ILoadingSpinnerProps {
	showText?: boolean;
	className?: string;
	textClassName?: string;
	svgClassName?: string;
	text?: string;
}

const LoadingSpinner = ({
	className = '',
	showText = true,
	text = 'Loading...',
	svgClassName = '',
	textClassName,
}: ILoadingSpinnerProps): ReactElement => (
	<div role="status" className={className}>
		<LoadingSpinnerIcon
			className={`text-gray-200 dark:text-gray-600 ml-2 inline h-6 w-6 animate-spin fill-primary ${svgClassName}`}
		/>
		{showText && <span className={`sr-only ${textClassName}`}>{text}</span>}
	</div>
);

export default LoadingSpinner;
